const HomeQueryKey = {
  FOOTER: 'FOOTER',
  RECOMMEND: 'RECOMMEND',
  LUXURY: 'LUXURY',
};

export default HomeQueryKey;
